import { createTheme } from '@mui/material'
const theme = createTheme({
  palette: {
    grey: {
      lightestGrey: '#fbfafa',
      lighterGrey: '#eeeeee',
      lightGrey: '#e6e6e6',
      darkGrey: '#777777',
      darkerGrey: '#404040',
      darkestGrey: '#222131'
    },
    red: {
      main: '#CD5B5B'
    },
    brand: {
      primary: {
        forest: '#36461C',
        parchment: '#FEFBEA',
        growth: '#80FFA5',
        midnight: '#1B2421'
      },
      secondary: {
        stone: '#CCCCB9',
        blueSuede: '#294660',
        sky: '#66A3E8',
        yellowhammer: '#FFF512'
      },
      tertiary: {
        butter: '#F7F7B1',
        sunny: '#F6C327',
        goldenrod: '#A9820A'
      }
    }
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: 'Source Sans Pro !important',
          fontWeight: 400
        }
      }
    },
    MuiListItemText: {
      styleOverrides: {
        root: {
          fontFamily: 'Source Sans Pro'
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: 400,
          padding: '3px 14px',
          '&:focus': {
            outline: 'none'
          }
        },
        contained: {
          color: '#FEFBEA',
          textTransform: 'none',
          '&:disabled': {
            color: '#A3A2A2',
            backgroundColor: '#F4F4F4'
          }
        },
        containedPrimary: {
          backgroundColor: '#36461C',
          color: '#FEFBEA',
          '&:hover': {
            backgroundColor: '#1B2421',
            color: '#FEFBEA'
          }
        },
        containedSecondary: {},
        containedError: {
          backgroundColor: '#cd2d2d',
          color: '#ffff',
          '&:hover': {
            backgroundColor: '#cd2d2dcf !important',
            color: '#ffff'
          },
          '&:focus': {
            outlineColor: '#ad211b'
          }
        },
        outlined: {
          textTransform: 'none',
          '&:disabled': {
            color: '#A3A2A2',
            backgroundColor: '#F4F4F4'
          }
        },
        outlinedPrimary: {
          color: '#36461C',
          borderColor: '#36461C',
          '&:hover': {
            color: '#1B2421',
            borderColor: '#1B2421'
          }
        },
        outlinedSecondary: {},
        outlinedError: {},
        text: {
          textTransform: 'none'
        },
        textPrimary: {},
        textSecondary: {},
        textError: {}
      }
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          '&:focus': {
            outline: 'none'
          }
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          fontSize: '12px',
          fontWeight: '400',
          textTransform: 'none',
          backgroundColor: '#F4F4F4',
          '& .MuiOutlinedInput-notchedOutline': {
            border: '1px solid #C4C4C4',
            '& legend': {
              width: 'auto'
            }
          },
          '&.Mui-focused': {
            '& .MuiOutlinedInput-notchedOutline': {
              border: '1px solid #A3A2A2'
            }
          }
        },
        input: {
          padding: '6px'
        }
      }
    },
    MuiInput: {
      defaultProps: {
        disableUnderline: true
      },
      styleOverrides: {
        root: {
          '&$underline:after': {
            borderBottom: '2px solid #C4C4C4'
          }
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        sizeSmall: {
          backgroundColor: '#36461C'
        },
        outlinedPrimary: {
          color: '#36461C',
          borderColor: '#36461C',
          backgroundColor: '#FEFBEA'
        }
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          '&.Mui-focused': {
            color: '#36461C'
          }
        }
      }
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          '&.Mui-checked': {
            color: '#36461C'
          }
        }
      }
    }
  }
})

export default theme
